import { render } from "./NuovoKit.vue?vue&type=template&id=0a9dfccd&scoped=true"
import script from "./NuovoKit.vue?vue&type=script&lang=js"
export * from "./NuovoKit.vue?vue&type=script&lang=js"

import "./NuovoKit.vue?vue&type=style&index=0&id=0a9dfccd&lang=css"
import "./NuovoKit.vue?vue&type=style&index=1&id=0a9dfccd&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9dfccd"]])

export default __exports__